{{#if (and isPipelinedWrite hasSlave)}}
virtual task wait_for_data_grant();
  {{ dataGrantsVariable.identifier }}.get(1);
endtask
{{/if}}
